import { useState, useEffect, useRef } from "react";

import { API } from "../config";
const FONT = "'DM Sans', sans-serif";
const MONO = "'IBM Plex Mono', monospace";

// ── Colonne quote per tab ────────────────────────────────────────
const QUOTE_ORE9 = [
  { campo: "q_1_ore9", label: "q_1" },
  { campo: "q_x_ore9", label: "q_x" },
  { campo: "q_2_ore9", label: "q_2" },
];

const QUOTE_5MKO = [
  { gruppo: "1X2 PUNTA", campi: [
    { campo: "qp_1", label: "qp_1" },
    { campo: "qp_x", label: "qp_x" },
    { campo: "qp_2", label: "qp_2" },
  ]},
  { gruppo: "1X2 BANCA", campi: [
    { campo: "qb_1", label: "qb_1" },
    { campo: "qb_x", label: "qb_x" },
    { campo: "qb_2", label: "qb_2" },
  ]},
  { gruppo: "O/U 1.5 PUNTA+BANCA", campi: [
    { campo: "qp_u15", label: "qp_u15" },
    { campo: "qp_o15", label: "qp_o15" },
    { campo: "qb_u15", label: "qb_u15" },
    { campo: "qb_o15", label: "qb_o15" },
  ]},
  { gruppo: "O/U 2.5 PUNTA+BANCA", campi: [
    { campo: "qp_u25", label: "qp_u25" },
    { campo: "qp_o25", label: "qp_o25" },
    { campo: "qb_u25", label: "qb_u25" },
    { campo: "qb_o25", label: "qb_o25" },
  ]},
  { gruppo: "O/U 3.5 PUNTA+BANCA", campi: [
    { campo: "qp_u35", label: "qp_u35" },
    { campo: "qp_o35", label: "qp_o35" },
    { campo: "qb_u35", label: "qb_u35" },
    { campo: "qb_o35", label: "qb_o35" },
  ]},
];

const QUOTE_ORE8 = [
  { gruppo: "1X2 PUNTA", campi: [
    { campo: "q_1_ore8", label: "q_1" },
    { campo: "q_x_ore8", label: "q_x" },
    { campo: "q_2_ore8", label: "q_2" },
  ]},
  { gruppo: "1X2 BANCA", campi: [
    { campo: "qb_1_ore8", label: "qb_1" },
    { campo: "qb_x_ore8", label: "qb_x" },
    { campo: "qb_2_ore8", label: "qb_2" },
  ]},
  { gruppo: "O/U 1.5 PUNTA+BANCA", campi: [
    { campo: "qp_u15_ore8", label: "qp_u15" },
    { campo: "qp_o15_ore8", label: "qp_o15" },
    { campo: "qb_u15_ore8", label: "qb_u15" },
    { campo: "qb_o15_ore8", label: "qb_o15" },
  ]},
  { gruppo: "O/U 2.5 PUNTA+BANCA", campi: [
    { campo: "qp_u25_ore8", label: "qp_u25" },
    { campo: "qp_o25_ore8", label: "qp_o25" },
    { campo: "qb_u25_ore8", label: "qb_u25" },
    { campo: "qb_o25_ore8", label: "qb_o25" },
  ]},
  { gruppo: "O/U 3.5 PUNTA+BANCA", campi: [
    { campo: "qp_u35_ore8", label: "qp_u35" },
    { campo: "qp_o35_ore8", label: "qp_o35" },
    { campo: "qb_u35_ore8", label: "qb_u35" },
    { campo: "qb_o35_ore8", label: "qb_o35" },
  ]},
  { gruppo: "BTTS PUNTA+BANCA", campi: [
    { campo: "qp_btts_si", label: "qp_btts_si" },
    { campo: "qp_btts_no", label: "qp_btts_no" },
    { campo: "qb_btts_si", label: "qb_btts_si" },
    { campo: "qb_btts_no", label: "qb_btts_no" },
  ]},
];

// ── Stili comuni ────────────────────────────────────────────────
const stili = {
  pagina: { padding: "24px 32px", fontFamily: FONT, background: "#FAFBFC", minHeight: "100vh" },
  titolo: { fontSize: 22, fontWeight: 700, color: "#1E293B", margin: "0 0 4px 0" },
  card: { background: "#fff", borderRadius: 10, border: "1px solid #E2E8F0", padding: "16px 20px", marginBottom: 16 },
  label: { fontSize: 11, fontWeight: 600, color: "#64748B", marginBottom: 4, display: "block", fontFamily: FONT },
  select: { fontFamily: FONT, fontSize: 13, padding: "6px 10px", borderRadius: 6, border: "1px solid #CBD5E1", background: "#fff", color: "#1E293B", minWidth: 140, outline: "none" },
  input: { fontFamily: FONT, fontSize: 13, padding: "6px 10px", borderRadius: 6, border: "1px solid #CBD5E1", background: "#fff", color: "#1E293B" },
  btn: { fontFamily: FONT, fontSize: 13, fontWeight: 600, padding: "7px 16px", borderRadius: 6, border: "none", cursor: "pointer", transition: "background 0.15s" },
  btnPrimary: { background: "#2563EB", color: "#fff" },
  btnSecondary: { background: "#F1F5F9", color: "#475569", border: "1px solid #CBD5E1" },
  btnDanger: { background: "#EF4444", color: "#fff" },
  th: { fontSize: 11, fontWeight: 700, color: "#64748B", padding: "8px 6px", textAlign: "left", borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap" },
  td: { fontSize: 12, padding: "7px 6px", color: "#334155", borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap", fontFamily: FONT },
};

// ── Helper: calcolo ciclo (identico a MonitorLive) ──────────────
function calcolaCiclo(data) {
  const giorno = data.getDay();
  let inizio, fine, tipo;
  if (giorno >= 2 && giorno <= 4) {
    tipo = "Midweek";
    inizio = new Date(data);
    inizio.setDate(data.getDate() - (giorno - 2));
    fine = new Date(inizio);
    fine.setDate(inizio.getDate() + 2);
  } else {
    tipo = "Weekend";
    inizio = new Date(data);
    if (giorno === 0) inizio.setDate(data.getDate() - 2);
    else if (giorno === 1) inizio.setDate(data.getDate() - 3);
    else if (giorno === 6) inizio.setDate(data.getDate() - 1);
    fine = new Date(inizio);
    fine.setDate(inizio.getDate() + 3);
  }
  return { tipo, inizio, fine };
}

function calcolaCicloPrecedente(data) {
  const cicloCorrente = calcolaCiclo(data);
  const giornoPrima = new Date(cicloCorrente.inizio);
  giornoPrima.setDate(giornoPrima.getDate() - 1);
  return calcolaCiclo(giornoPrima);
}

function toISODate(d) {
  if (!d) return "";
  if (typeof d === "string") return d.slice(0, 10);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

function fmtDataIT(d) {
  if (!d) return "";
  if (typeof d === "string") {
    const [y, m, dd] = d.slice(0, 10).split("-");
    return `${dd}/${m}/${y}`;
  }
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

function fmtData(d) {
  if (!d) return "";
  try {
    const giorni = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
    const [y, m, dd] = d.split("-");
    const dt = new Date(parseInt(y), parseInt(m) - 1, parseInt(dd));
    return `${giorni[dt.getDay()]} ${dd}/${m}/${y}`;
  } catch { return d; }
}

function fmtTimestamp(ts) {
  if (!ts) return "—";
  // v194: i timestamp del DB arrivano con la T fra data e ora
  // (2026-05-19T11:24:15.221574), non con lo spazio.
  const s = String(ts).replace("T", " ");
  const [datePart, timePart] = s.split(" ");
  if (!datePart || !timePart) return s;
  const giorni = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
  const [y, mo, dd] = datePart.split("-");
  const dt = new Date(parseInt(y), parseInt(mo) - 1, parseInt(dd));
  const hhmm = timePart.substring(0, 5);
  return `${giorni[dt.getDay()]} ${dd}/${mo}/${y} ${hhmm}`;
}

function fmtOra(v) {
  if (!v) return "";
  return String(v).length >= 5 ? String(v).substring(0, 5) : String(v);
}

// ── Lista piatta campi 5mKO (per prefisso badge) ─────────────────
const CAMPI_5MKO = QUOTE_5MKO.flatMap(g => g.campi.map(c => c.campo));

// ── Badge anomalia ───────────────────────────────────────────────
function BadgeAnomalia({ tipo }) {
  const cfg = {
    quota_mancante: { bg: "#FFEBEE", color: "#C62828", label: "Quota mancante" },
    quota_bassa:    { bg: "#FFF8E1", color: "#F57F17", label: "Quota ≤1.01" },
    risultato_ht_mancante: { bg: "#F3E5F5", color: "#6A1B9A", label: "Risultato HT mancante" },
    risultato_ft_mancante: { bg: "#E3F2FD", color: "#1565C0", label: "Risultato FT mancante" },
  };
  // Determina tipo base
  const tipoBase = tipo.startsWith("quota_mancante") ? "quota_mancante"
    : tipo.startsWith("quota_bassa") ? "quota_bassa"
    : tipo;
  const c = cfg[tipoBase] || { bg: "#F1F5F9", color: "#475569", label: tipo };
  // Per quota: mostra anche il campo, con prefisso "5mKO: " se appartiene alle 5mKO
  const campo = tipo.includes(":") ? tipo.split(":")[1] : null;
  const dettaglio = campo
    ? ` (${CAMPI_5MKO.includes(campo) ? "5mKO: " : ""}${campo})`
    : "";
  return (
    <span style={{
      display: "inline-block", padding: "2px 7px", borderRadius: 4,
      fontSize: 10, fontWeight: 600, background: c.bg, color: c.color,
      marginRight: 4, marginBottom: 2, whiteSpace: "nowrap",
    }}>
      {c.label}{dettaglio}
    </span>
  );
}

// ── Modale di conferma ───────────────────────────────────────────
function Modale({ titolo, messaggio, onConferma, onAnnulla, pericoloso }) {
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
      zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "#fff", borderRadius: 12, padding: "28px 32px",
        maxWidth: 420, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        fontFamily: FONT,
      }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#1E293B", marginBottom: 10 }}>
          {titolo}
        </div>
        <div style={{ fontSize: 13, color: "#475569", marginBottom: 24, lineHeight: 1.6 }}>
          {messaggio}
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button style={{ ...stili.btn, ...stili.btnSecondary }} onClick={onAnnulla}>
            Annulla
          </button>
          <button
            style={{ ...stili.btn, ...(pericoloso ? stili.btnDanger : stili.btnPrimary) }}
            onClick={onConferma}
          >
            Conferma
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Campo quota modificabile ─────────────────────────────────────
function CampoQuota({ campo, valore, anomalie, onChange }) {
  const isAnomala = anomalie && anomalie.some(a => a.includes(campo));
  const borderColor = isAnomala ? "#EF4444" : "#CBD5E1";
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <span style={{ fontSize: 10, fontWeight: 600, color: "#94A3B8", fontFamily: MONO }}>
        {campo}
      </span>
      <input
        type="number"
        step="0.01"
        value={valore ?? ""}
        onChange={e => onChange(campo, e.target.value === "" ? null : parseFloat(e.target.value))}
        placeholder="—"
        style={{
          ...stili.input,
          width: 80, textAlign: "center", fontFamily: MONO, fontSize: 13,
          border: `1px solid ${borderColor}`,
          background: isAnomala ? "#FFF5F5" : "#fff",
        }}
      />
    </div>
  );
}

// ── Testi popup conferma per tab ─────────────────────────────────
const MSG_CONFERMA = {
  ore9:      "Sei sicuro di voler salvare? Verranno ricalcolati: Aggio Betfair, Quote INS, Delta quote (ore9 - INS), Delta quote (5mKO - ore9) e P/L ore 9.",
  "5mko":    "Sei sicuro di voler salvare le modifiche? Verranno ricalcolati: delta quote 1X2 (ore 9 vs 5mKO) e P/L 5mKO.",
  ore8:      "Sei sicuro di voler salvare le modifiche? Verrà ricalcolato: P/L ore 8.",
  ht:        "Sei sicuro di voler salvare il risultato?",
  ft:        "Sei sicuro di voler salvare il risultato? L'inserimento del risultato finale comporta il ricalcolo dei P/L di questa partita e impatta ELO, classifica e forma delle partite successive.",
};

// ── Pannello espanso partita ─────────────────────────────────────
function PannelloPartita({ partita, anomalie, onSalva, onElimina, onChiudi, onToast }) {
  const [tabAttivo, setTabAttivo] = useState("ore9");
  const [valori, setValori] = useState({});
  const [modale, setModale] = useState(null); // "salva" | "elimina"
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState("");
  const [hasFTModificato, setHasFTModificato] = useState(false);

  // Inizializza valori dal DB
  useEffect(() => {
    const init = {};
    [...QUOTE_ORE9, ...QUOTE_5MKO.flatMap(g => g.campi), ...QUOTE_ORE8.flatMap(g => g.campi)].forEach(({ campo }) => {
      init[campo] = partita[campo] ?? null;
    });
    init.ht_gol_home = partita.ht_gol_home ?? null;
    init.ht_gol_away = partita.ht_gol_away ?? null;
    init.et_gol_home = partita.et_gol_home ?? null;
    init.et_gol_away = partita.et_gol_away ?? null;
    setValori(init);
    setMsg("");
    setHasFTModificato(false);
  }, [partita]);

  const handleChange = (campo, valore) => {
    setValori(prev => ({ ...prev, [campo]: valore }));
  };

  // Determina il messaggio di conferma in base al tab e ai campi modificati
  const getMsgConferma = () => {
    if (tabAttivo === "risultati") {
      const ftModificato = (valori["et_gol_home"] ?? null) !== (partita["et_gol_home"] ?? null)
                        || (valori["et_gol_away"] ?? null) !== (partita["et_gol_away"] ?? null);
      return ftModificato ? MSG_CONFERMA.ft : MSG_CONFERMA.ht;
    }
    return MSG_CONFERMA[tabAttivo] || "Sei sicuro di voler salvare le modifiche?";
  };

  const handleSalva = async () => {
    setSalvando(true);
    setMsg("");
    setModale(null);
    try {
      const campiQuote = [...QUOTE_ORE9, ...QUOTE_5MKO.flatMap(g => g.campi), ...QUOTE_ORE8.flatMap(g => g.campi)].map(c => c.campo);
      const campiRisultato = ["ht_gol_home", "ht_gol_away", "et_gol_home", "et_gol_away"];
      const errori = [];
      let ftSalvato = false;

      // Salva quote modificate (una per una)
      for (const campo of campiQuote) {
        const originale = partita[campo] ?? null;
        const nuovo = valori[campo] ?? null;
        if (nuovo !== originale) {
          const r = await fetch(`${API}/partite/${partita.id}/quota`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ campo, valore: nuovo }),
          });
          if (!r.ok) { errori.push(campo); continue; }
          await fetch(`${API}/interventi`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              partita_id: partita.id,
              tipo: "Modifica quota",
              campo,
              valore_prima: originale !== null ? String(originale) : null,
              valore_dopo: nuovo !== null ? String(nuovo) : null,
            }),
          });
        }
      }

      // Salva risultati modificati (tutti insieme)
      const aggRis = {};
      for (const campo of campiRisultato) {
        const originale = partita[campo] ?? null;
        const nuovo = valori[campo] ?? null;
        if (nuovo !== originale) aggRis[campo] = nuovo;
      }
      if (Object.keys(aggRis).length > 0) {
        const r = await fetch(`${API}/partite/${partita.id}/risultato`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(aggRis),
        });
        if (!r.ok) errori.push("risultati");
        else {
          for (const [campo, nuovo] of Object.entries(aggRis)) {
            await fetch(`${API}/interventi`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                partita_id: partita.id,
                tipo: "Inserimento risultato",
                campo,
                valore_prima: partita[campo] !== null && partita[campo] !== undefined ? String(partita[campo]) : null,
                valore_dopo: nuovo !== null ? String(nuovo) : null,
              }),
            });
          }
          // Controlla se FT è stato modificato
          if (aggRis["et_gol_home"] !== undefined || aggRis["et_gol_away"] !== undefined) {
            ftSalvato = true;
          }
        }
      }

      if (errori.length > 0) {
        setMsg(`⚠️ Errore su: ${errori.join(", ")}`);
        return;
      }

      // Se FT modificato → ricalcolo automatico P/L + parametri partite successive
      if (ftSalvato) {
        setMsg("⏳ Ricalcolo P/L in corso...");
        try {
          const rRic = await fetch(`${API}/partite/${partita.id}/ricalcola-risultato`, { method: "POST" });
          if (!rRic.ok) {
            const dErr = await rRic.json().catch(() => ({}));
            const motivo = dErr.detail || `HTTP ${rRic.status}`;
            if (onToast) onToast(`⚠️ Risultato salvato, ma ricalcolo P/L fallito: ${motivo}. Riprovare manualmente.`);
          } else {
            if (onToast) onToast("✅ Risultato salvato. P/L della partita ricalcolati. I parametri statistici (ELO, classifica, forma) delle partite dei cicli successivi verranno aggiornati dal prossimo ciclo MARVEN.");
          }
        } catch (eRic) {
          if (onToast) onToast(`⚠️ Risultato salvato, ma ricalcolo P/L fallito: ${eRic.message}. Riprovare manualmente.`);
        }
        onSalva();
        return;
      }

      // Se solo quote → ricalcolo automatico
      const tipoQuote = tabAttivo === "ore9" ? "ore9" : tabAttivo === "5mko" ? "5mko" : tabAttivo === "ore8" ? "ore8" : null;
      if (tipoQuote) {
        await fetch(`${API}/partite/${partita.id}/ricalcola-quote?tipo=${tipoQuote}`, { method: "POST" });
        if (onToast) onToast("✅ Modifiche salvate. Ricalcolo completato.\n💡 Ricorda: se hai finito di inserire tutte le quote mancanti, lancia il ricalcolo delle selezioni del ciclo corrente.");
      } else {
        if (onToast) onToast("✅ Modifiche salvate.");
      }
      onSalva();
    } catch (e) {
      setMsg(`❌ Errore: ${e.message}`);
    } finally {
      setSalvando(false);
    }
  };

  const handleElimina = async () => {
    setModale(null);
    try {
      const r = await fetch(`${API}/partite/${partita.id}`, { method: "DELETE" });
      if (!r.ok) throw new Error("Errore eliminazione");
      await fetch(`${API}/interventi`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          partita_id: partita.id,
          tipo: "Eliminazione partita",
          campo: "partita",
          valore_prima: `${partita.casa} - ${partita.trasferta} (${partita.data})`,
          valore_dopo: null,
        }),
      });
      onElimina();
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    }
  };

  const TABS = ["ore9", "5mko", "ore8", "risultati"];
  const TAB_LABEL = { ore9: "Ore 9", "5mko": "5mKO", ore8: "Ore 8", risultati: "Risultati" };

  return (
    <div style={{
      background: "#F8FAFC", border: "1px solid #CBD5E1",
      borderRadius: 10, padding: "20px 24px", marginTop: 4,
    }}>
      {/* Anagrafica */}
      <div style={{ display: "flex", gap: 32, marginBottom: 16, flexWrap: "wrap" }}>
        {[
          { label: "Data", val: fmtData(partita.data) + (partita.data ? ` ${partita.data.slice(0,4)}` : "") },
          { label: "Ora", val: fmtOra(partita.time_it) },
          { label: "Lega", val: partita.lega },
          { label: "Casa", val: partita.casa },
          { label: "Trasferta", val: partita.trasferta },
        ].map(({ label, val }) => (
          <div key={label}>
            <span style={stili.label}>{label}</span>
            <span style={{ fontSize: 14, fontWeight: 600, color: "#1E293B" }}>{val || "—"}</span>
          </div>
        ))}
      </div>

      {/* Tab */}
      <div style={{ display: "flex", gap: 0, marginBottom: 16, borderBottom: "2px solid #E2E8F0" }}>
        {TABS.map(tab => (
          <button key={tab} onClick={() => setTabAttivo(tab)} style={{
            fontFamily: FONT, fontSize: 13, fontWeight: tabAttivo === tab ? 700 : 500,
            color: tabAttivo === tab ? "#2563EB" : "#64748B",
            background: "none", border: "none", cursor: "pointer",
            padding: "8px 18px",
            borderBottom: tabAttivo === tab ? "2px solid #2563EB" : "2px solid transparent",
            marginBottom: -2,
          }}>
            {TAB_LABEL[tab]}
          </button>
        ))}
      </div>

      {/* Contenuto tab Ore 9 */}
      {tabAttivo === "ore9" && (
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {QUOTE_ORE9.map(({ campo, label }) => (
            <CampoQuota key={campo} campo={label} valore={valori[campo]} anomalie={anomalie} onChange={(_, v) => handleChange(campo, v)} />
          ))}
        </div>
      )}

      {/* Contenuto tab 5mKO */}
      {tabAttivo === "5mko" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {QUOTE_5MKO.map(({ gruppo, campi }) => (
            <div key={gruppo}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                {gruppo}
              </div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {campi.map(({ campo, label }) => (
                  <CampoQuota key={campo} campo={label} valore={valori[campo]} anomalie={anomalie} onChange={(_, v) => handleChange(campo, v)} />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Contenuto tab Ore 8 */}
      {tabAttivo === "ore8" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {QUOTE_ORE8.map(({ gruppo, campi }) => (
            <div key={gruppo}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                {gruppo}
              </div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {campi.map(({ campo, label }) => (
                  <CampoQuota key={campo} campo={label} valore={valori[campo]} anomalie={anomalie} onChange={(_, v) => handleChange(campo, v)} />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Contenuto tab Risultati */}
      {tabAttivo === "risultati" && (
        <div style={{ display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", marginBottom: 8, textTransform: "uppercase" }}>HT</div>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {["ht_gol_home", "ht_gol_away"].map(campo => (
                <div key={campo} style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: 10, fontWeight: 600, color: "#94A3B8", fontFamily: MONO }}>{campo}</span>
                  <input
                    type="number" min="0" step="1"
                    value={valori[campo] ?? ""}
                    onChange={e => handleChange(campo, e.target.value === "" ? null : parseInt(e.target.value))}
                    placeholder="—"
                    style={{
                      ...stili.input, width: 64, textAlign: "center", fontFamily: MONO, fontSize: 14,
                      border: `1px solid ${anomalie && anomalie.includes("risultato_ht_mancante") ? "#EF4444" : "#CBD5E1"}`,
                      background: anomalie && anomalie.includes("risultato_ht_mancante") ? "#FFF5F5" : "#fff",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", marginBottom: 8, textTransform: "uppercase" }}>FT</div>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {["et_gol_home", "et_gol_away"].map(campo => (
                <div key={campo} style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: 10, fontWeight: 600, color: "#94A3B8", fontFamily: MONO }}>{campo}</span>
                  <input
                    type="number" min="0" step="1"
                    value={valori[campo] ?? ""}
                    onChange={e => handleChange(campo, e.target.value === "" ? null : parseInt(e.target.value))}
                    placeholder="—"
                    style={{
                      ...stili.input, width: 64, textAlign: "center", fontFamily: MONO, fontSize: 14,
                      border: `1px solid ${anomalie && anomalie.includes("risultato_ft_mancante") ? "#EF4444" : "#CBD5E1"}`,
                      background: anomalie && anomalie.includes("risultato_ft_mancante") ? "#FFF5F5" : "#fff",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Azioni */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <button
            style={{ ...stili.btn, ...stili.btnPrimary, opacity: salvando ? 0.7 : 1 }}
            onClick={() => setModale("salva")}
            disabled={salvando}
          >
            {salvando ? "Salvataggio..." : "Salva modifiche"}
          </button>
          <button style={{ ...stili.btn, ...stili.btnSecondary }} onClick={onChiudi}>
            Chiudi
          </button>
          {msg && <span style={{ fontSize: 12, color: msg.startsWith("✅") ? "#16A34A" : msg.startsWith("⏳") ? "#64748B" : "#DC2626", whiteSpace: "pre-line" }}>{msg}</span>}
        </div>
      </div>

      {/* v202: eliminazione staccata dal salvataggio — agisce sulla partita
          intera, non sulla scheda aperta. Nessun cambio di comportamento. */}
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        gap: 16, marginTop: 18, paddingTop: 14, borderTop: "1px solid #E2E8F0",
      }}>
        <span style={{ fontSize: 12, color: "#64748B" }}>
          Rimuove la partita e tutti i suoi dati. Irreversibile.
        </span>
        <button
          style={{ ...stili.btn, ...stili.btnDanger, fontSize: 12, padding: "5px 12px" }}
          onClick={() => setModale("elimina")}
        >
          🗑 Elimina partita
        </button>
      </div>

      {/* Modale conferma salvataggio (dinamico per tab) */}
      {modale === "salva" && (
        <Modale
          titolo="Conferma salvataggio"
          messaggio={getMsgConferma()}
          onConferma={handleSalva}
          onAnnulla={() => setModale(null)}
        />
      )}

      {/* Modale conferma eliminazione */}
      {modale === "elimina" && (
        <Modale
          titolo="Elimina partita"
          messaggio={`Stai per eliminare definitivamente la partita ${partita.casa} - ${partita.trasferta} del ${partita.data}. Questa operazione è irreversibile.`}
          onConferma={handleElimina}
          onAnnulla={() => setModale(null)}
          pericoloso
        />
      )}
    </div>
  );
}

// ── Sezione 1: Anomalie su quote e/o risultati ───────────────────
function SezioneAnomalie({ onIntervento, onToast }) {
  const oggi = new Date();
  const cicloCorrente = calcolaCiclo(oggi);
  const cicloPrecedente = calcolaCicloPrecedente(oggi);

  const [periodo, setPeriodo] = useState("corrente");
  const [dataDA, setDataDA] = useState("");
  const [dataA, setDataA] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [anomalie, setAnomalie] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");
  const [rigaAperta, setRigaAperta] = useState(null);
  const [contatore, setContatore] = useState(0);
  const [cicloAttivo, setCicloAttivo] = useState(null); // null=caricamento, {attivo,tipo,inizio,fine}
  const [ricalcoloSel, setRicalcoloSel] = useState({ loading: false, msg: "" });
  const [daArchiviare, setDaArchiviare] = useState(null);

  // v202 (D677): archivia le sole anomalie sulle QUOTE di una partita.
  // Non modifica alcun dato: le quote restano come sono.
  const archiviaAnomalie = async () => {
    const p = daArchiviare;
    setDaArchiviare(null);
    if (!p) return;
    try {
      const r = await fetch(`${API}/anomalie/${p.id}/archivia`, { method: "POST" });
      if (!r.ok) throw new Error("Errore archiviazione");
      setContatore(c => c + 1);
      onIntervento();
      onToast && onToast(`Segnalazioni archiviate: ${p.casa} - ${p.trasferta}`);
    } catch (e) {
      setErrore(e.message);
    }
  };

  const dateEffettive = (() => {
    if (periodo === "corrente") return { da: toISODate(cicloCorrente.inizio), a: toISODate(cicloCorrente.fine) };
    if (periodo === "precedente") return { da: toISODate(cicloPrecedente.inizio), a: toISODate(cicloPrecedente.fine) };
    return { da: dataDA, a: dataA };
  })();

  const periodoLabel = (() => {
    if (periodo === "corrente") return `${cicloCorrente.tipo} ${fmtDataIT(cicloCorrente.inizio)} – ${fmtDataIT(cicloCorrente.fine)}`;
    if (periodo === "precedente") return `${cicloPrecedente.tipo} ${fmtDataIT(cicloPrecedente.inizio)} – ${fmtDataIT(cicloPrecedente.fine)}`;
    if (dataDA || dataA) return `${dataDA || "..."} → ${dataA || "..."}`;
    return "";
  })();

  const carica = async () => {
    if (periodo === "personalizzato" && (!dataDA || !dataA)) return;
    setLoading(true);
    setErrore("");
    setRigaAperta(null);
    try {
      let url = `${API}/anomalie?da=${dateEffettive.da}&a=${dateEffettive.a}`;
      if (filtroTipo) url += `&filtro=${filtroTipo}`;
      const r = await fetch(url);
      if (!r.ok) throw new Error(`Errore ${r.status}`);
      const data = await r.json();
      setAnomalie(Array.isArray(data) ? data : []);
    } catch (e) {
      setErrore(e.message);
      setAnomalie([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { carica(); }, [periodo, dataDA, dataA, filtroTipo, contatore]);

  useEffect(() => {
    fetch(`${API}/ciclo-corrente`)
      .then(r => r.json())
      .then(d => setCicloAttivo(d))
      .catch(() => setCicloAttivo({ attivo: false }));
  }, []);

  const ricalcolaSelezioni = async () => {
    if (!cicloAttivo || !cicloAttivo.attivo) {
      setRicalcoloSel({ loading: false, msg: "⚠️ Nessun ciclo attivo al momento." });
      return;
    }
    setRicalcoloSel({ loading: true, msg: "" });
    try {
      // v102: usa endpoint con diff (snapshot prima/dopo + post-it banner)
      // Risposta retrocompatibile: contiene ancora esito/dettaglio/nuove/aggiornate.
      const r = await fetch(`${API}/pipeline/ricalcola-selezioni-con-diff`, { method: "POST" });
      const d = await r.json();
      const cicloInfo = `${cicloAttivo.tipo} ${fmtDataIT(cicloAttivo.inizio)} – ${fmtDataIT(cicloAttivo.fine)}`;
      const partite = d.partite_valutate !== undefined ? `Partite valutate: ${d.partite_valutate}.` : "";
      const selezioni = d.selezioni_aggiornate !== undefined ? `Selezioni aggiornate: ${d.selezioni_aggiornate}.` : "";
      const esito = d.esito || d.dettaglio || "OK";
      const parti = [`✅ Ciclo: ${cicloInfo}.`, partite, selezioni, `Esito: ${esito}`]
        .filter(Boolean)
        .join(" ");
      setRicalcoloSel({ loading: false, msg: parti });
    } catch (e) {
      setRicalcoloSel({ loading: false, msg: `❌ Errore: ${e.message}` });
    }
  };

  const FILTRI = [
    { val: "", label: "Tutti" },
    { val: "quote_mancanti", label: "Quote mancanti" },
    { val: "quote_basse", label: "Quote ≤1.01" },
    { val: "ht_mancante", label: "Risultato HT mancante" },
    { val: "ft_mancante", label: "Risultato FT mancante" },
  ];

  return (
    <div style={stili.card}>
      {/* Header sezione */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
          Anomalie su quote e/o risultati
        </span>
        {!loading && anomalie.length > 0 && (
          <span style={{
            background: "#FFEBEE", color: "#C62828", fontSize: 11,
            fontWeight: 700, padding: "2px 8px", borderRadius: 10,
          }}>
            {anomalie.length} {anomalie.length === 1 ? "partita" : "partite"}
          </span>
        )}
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12, color: "#64748B" }}>Periodo:</span>
          <select style={stili.select} value={periodo} onChange={e => setPeriodo(e.target.value)}>
            <option value="corrente">Ciclo corrente</option>
            <option value="precedente">Ciclo precedente</option>
            <option value="personalizzato">Personalizzato</option>
          </select>
          {periodoLabel && (
            <span style={{
              fontSize: 11, color: "#64748B", background: "#F1F5F9",
              padding: "4px 10px", borderRadius: 6, whiteSpace: "nowrap",
            }}>
              {periodoLabel}
            </span>
          )}
        </div>
      </div>

      {/* Date personalizzate */}
      {periodo === "personalizzato" && (
        <div style={{ display: "flex", gap: 12, marginBottom: 12, alignItems: "flex-end" }}>
          <div>
            <span style={stili.label}>Da</span>
            <input type="date" style={stili.input} value={dataDA} onChange={e => setDataDA(e.target.value)} />
          </div>
          <div>
            <span style={stili.label}>A</span>
            <input type="date" style={stili.input} value={dataA} onChange={e => setDataA(e.target.value)} />
          </div>
        </div>
      )}

      {/* Filtri tipo anomalia */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
        <span style={{ fontSize: 12, color: "#64748B", alignSelf: "center" }}>Filtra:</span>
        {FILTRI.map(f => (
          <button
            key={f.val}
            onClick={() => setFiltroTipo(f.val)}
            style={{
              fontFamily: FONT, fontSize: 12, fontWeight: 600,
              padding: "4px 12px", borderRadius: 20, border: "none", cursor: "pointer",
              background: filtroTipo === f.val ? "#2563EB" : "#F1F5F9",
              color: filtroTipo === f.val ? "#fff" : "#475569",
              transition: "background 0.15s",
            }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Pulsante ricalcola selezioni ciclo corrente */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 14, flexWrap: "wrap" }}>
        <div>
          <button
            style={{
              ...stili.btn,
              background: cicloAttivo && cicloAttivo.attivo ? "#7C3AED" : "#CBD5E1",
              color: cicloAttivo && cicloAttivo.attivo ? "#fff" : "#94A3B8",
              cursor: cicloAttivo && cicloAttivo.attivo ? "pointer" : "not-allowed",
              opacity: ricalcoloSel.loading ? 0.6 : 1,
              fontSize: 13,
            }}
            onClick={ricalcolaSelezioni}
            disabled={!cicloAttivo || !cicloAttivo.attivo || ricalcoloSel.loading}
            title={
              !cicloAttivo ? "Verifica in corso..." :
              !cicloAttivo.attivo ? "Nessun ciclo attivo" :
              `Ciclo attivo: ${cicloAttivo.tipo} ${fmtDataIT(cicloAttivo.inizio)} – ${fmtDataIT(cicloAttivo.fine)}`
            }
          >
            {ricalcoloSel.loading ? "⏳ Ricalcolo in corso..." : "🔄 Ricalcola selezioni ciclo corrente"}
          </button>
          <div style={{ fontSize: 11, color: "#64748B", marginTop: 5, maxWidth: 380 }}>
            Da lanciare dopo aver inserito o corretto quote manualmente per aggiornare le selezioni del ciclo attivo.
          </div>
        </div>
        {ricalcoloSel.msg && (
          <div style={{
            fontSize: 12,
            color: ricalcoloSel.msg.startsWith("✅") ? "#16A34A" : ricalcoloSel.msg.startsWith("❌") ? "#DC2626" : "#92400E",
            background: ricalcoloSel.msg.startsWith("✅") ? "#F0FDF4" : ricalcoloSel.msg.startsWith("❌") ? "#FEF2F2" : "#FFFBEB",
            border: `1px solid ${ricalcoloSel.msg.startsWith("✅") ? "#BBF7D0" : ricalcoloSel.msg.startsWith("❌") ? "#FECACA" : "#FDE68A"}`,
            borderRadius: 6, padding: "6px 12px", alignSelf: "flex-start", maxWidth: 500,
          }}>
            {ricalcoloSel.msg}
          </div>
        )}
      </div>

      {/* Stato */}
      {loading && <div style={{ fontSize: 13, color: "#64748B", padding: "12px 0" }}>Caricamento...</div>}
      {errore && <div style={{ fontSize: 13, color: "#EF4444", padding: "8px 0" }}>⚠️ {errore}</div>}

      {/* Tabella */}
      {!loading && !errore && (
        anomalie.length === 0 ? (
          <div style={{ fontSize: 13, color: "#94A3B8", padding: "16px 0" }}>
            Nessuna anomalia rilevata nel periodo selezionato.
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  {["Data", "Ora", "Lega", "Casa", "Trasferta", "Anomalie rilevate", "Azioni"].map(h => (
                    <th key={h} style={h === "Azioni" ? { ...stili.th, textAlign: "right" } : stili.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {anomalie.map(p => {
                  const aperto = rigaAperta === p.id;
                  return (
                    <>
                      <tr key={p.id} style={{ background: aperto ? "#EFF6FF" : "transparent" }}>
                        <td style={stili.td}>{fmtData(p.data)}</td>
                        <td style={stili.td}>{fmtOra(p.time_it)}</td>
                        <td style={stili.td}>{p.lega}</td>
                        <td style={{ ...stili.td, fontWeight: 600 }}>{p.casa}</td>
                        <td style={{ ...stili.td, fontWeight: 600 }}>{p.trasferta}</td>
                        <td style={{ ...stili.td, maxWidth: 320 }}>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                            {(p.anomalie || []).map((a, i) => <BadgeAnomalia key={i} tipo={a} />)}
                          </div>
                        </td>
                        <td style={stili.td}>
                          <div style={{ display: "flex", flexDirection: "column", gap: 5, alignItems: "flex-end" }}>
                            <button
                              style={{
                                ...stili.btn,
                                ...(aperto ? stili.btnSecondary : stili.btnPrimary),
                                fontSize: 12, padding: "4px 12px", whiteSpace: "nowrap",
                              }}
                              onClick={() => setRigaAperta(aperto ? null : p.id)}
                            >
                              {aperto ? "Chiudi" : "Intervieni"}
                            </button>
                            {(p.anomalie || []).some(a => a.startsWith("quota_")) && (
                              <button
                                style={{
                                  ...stili.btn, fontSize: 11, padding: "3px 10px",
                                  whiteSpace: "nowrap", background: "transparent",
                                  color: "#64748B", border: "1px solid #CBD5E1",
                                }}
                                onClick={() => setDaArchiviare(p)}
                              >
                                ✓ Segna come risolto
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                      {aperto && (
                        <tr key={`panel-${p.id}`}>
                          <td colSpan={7} style={{ padding: "0 8px 8px 8px", background: "#EFF6FF" }}>
                            <PannelloPartita
                              partita={p}
                              anomalie={p.anomalie || []}
                              onSalva={() => { setRigaAperta(null); setContatore(c => c + 1); onIntervento(); }}
                              onElimina={() => { setRigaAperta(null); setContatore(c => c + 1); onIntervento(); }}
                              onChiudi={() => setRigaAperta(null)}
                              onToast={onToast}
                            />
                          </td>
                        </tr>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        )
      )}
      {/* v202 (D677): conferma archiviazione anomalie quote */}
      {daArchiviare && (
        <Modale
          titolo="Segna come risolto"
          messaggio={
            `Archivio le ${(daArchiviare.anomalie || []).filter(a => a.startsWith("quota_")).length} segnalazioni sulle quote di ` +
            `${daArchiviare.casa} - ${daArchiviare.trasferta} del ${fmtData(daArchiviare.data)}. ` +
            `Le quote restano vuote: non viene modificato alcun dato. La partita smette di comparire ` +
            `fra le anomalie in Interventi su DB, Dashboard e Monitor Live. ` +
            `Eventuali risultati mancanti continueranno a essere segnalati.`
          }
          onConferma={archiviaAnomalie}
          onAnnulla={() => setDaArchiviare(null)}
        />
      )}
    </div>
  );
}

// ── Sezione 2: Ricerca libera ────────────────────────────────────
function SezioneRicercaLibera({ onIntervento, onToast }) {
  const [data, setData] = useState("");
  const [lega, setLega] = useState("");
  const [squadra, setSquadra] = useState("");
  const [legheLista, setLegheLista] = useState([]);
  const [risultati, setRisultati] = useState([]);
  const [cercato, setCercato] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");
  const [rigaAperta, setRigaAperta] = useState(null);

  useEffect(() => {
    fetch(`${API}/campionati`).then(r => r.json())
      .then(d => { if (Array.isArray(d)) setLegheLista(d.map(c => c.nome_bf || c.nome || String(c))); })
      .catch(() => {});
  }, []);

  const cerca = async () => {
    if (!data && !lega && !squadra) return;
    setLoading(true);
    setErrore("");
    setRigaAperta(null);
    setCercato(true);
    try {
      const params = new URLSearchParams();
      if (data) params.append("data", data);
      if (lega) params.append("lega", lega);
      if (squadra) params.append("squadra", squadra);
      const r = await fetch(`${API}/partite/cerca?${params.toString()}`);
      if (!r.ok) throw new Error(`Errore ${r.status}`);
      const d = await r.json();
      setRisultati(Array.isArray(d) ? d : []);
    } catch (e) {
      setErrore(e.message);
      setRisultati([]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") cerca(); };

  return (
    <div style={stili.card}>
      <div style={{ fontSize: 15, fontWeight: 700, color: "#1E293B", marginBottom: 14 }}>
        Ricerca libera
      </div>

      {/* Filtri ricerca */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 14 }}>
        <div>
          <span style={stili.label}>Data</span>
          <input
            type="date" style={stili.input} value={data}
            onChange={e => setData(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div>
          <span style={stili.label}>Lega</span>
          <select style={stili.select} value={lega} onChange={e => setLega(e.target.value)}>
            <option value="">Tutte</option>
            {legheLista.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <span style={stili.label}>Squadra</span>
          <input
            style={{ ...stili.input, width: 180 }}
            placeholder="Casa o trasferta..."
            value={squadra}
            onChange={e => setSquadra(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <button style={{ ...stili.btn, ...stili.btnPrimary }} onClick={cerca}>
          Cerca
        </button>
      </div>

      {/* Stato */}
      {loading && <div style={{ fontSize: 13, color: "#64748B" }}>Ricerca in corso...</div>}
      {errore && <div style={{ fontSize: 13, color: "#EF4444" }}>⚠️ {errore}</div>}

      {/* Risultati */}
      {!loading && !errore && cercato && (
        risultati.length === 0 ? (
          <div style={{ fontSize: 13, color: "#94A3B8", padding: "8px 0" }}>
            Nessuna partita trovata.
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  {["Data", "Ora", "Lega", "Casa", "Trasferta", "HT", "FT", "Azioni"].map(h => (
                    <th key={h} style={stili.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {risultati.map(p => {
                  const aperto = rigaAperta === p.id;
                  const ht = p.ht_gol_home !== null && p.ht_gol_home !== undefined
                    ? `${p.ht_gol_home}-${p.ht_gol_away}` : "—";
                  const ft = p.et_gol_home !== null && p.et_gol_home !== undefined
                    ? `${p.et_gol_home}-${p.et_gol_away}` : "—";
                  return (
                    <>
                      <tr key={p.id} style={{ background: aperto ? "#EFF6FF" : "transparent" }}>
                        <td style={stili.td}>{fmtData(p.data)}</td>
                        <td style={stili.td}>{fmtOra(p.time_it)}</td>
                        <td style={stili.td}>{p.lega}</td>
                        <td style={{ ...stili.td, fontWeight: 600 }}>{p.casa}</td>
                        <td style={{ ...stili.td, fontWeight: 600 }}>{p.trasferta}</td>
                        <td style={{ ...stili.td, fontFamily: MONO }}>{ht}</td>
                        <td style={{ ...stili.td, fontFamily: MONO }}>{ft}</td>
                        <td style={stili.td}>
                          <button
                            style={{
                              ...stili.btn,
                              ...(aperto ? stili.btnSecondary : stili.btnPrimary),
                              fontSize: 12, padding: "5px 12px",
                            }}
                            onClick={() => setRigaAperta(aperto ? null : p.id)}
                          >
                            {aperto ? "Chiudi" : "Intervieni"}
                          </button>
                        </td>
                      </tr>
                      {aperto && (
                        <tr key={`panel-${p.id}`}>
                          <td colSpan={8} style={{ padding: "0 8px 8px 8px", background: "#EFF6FF" }}>
                            <PannelloPartita
                              partita={p}
                              anomalie={[]}
                              onSalva={() => { setRigaAperta(null); onIntervento(); cerca(); }}
                              onElimina={() => { setRigaAperta(null); onIntervento(); cerca(); }}
                              onChiudi={() => setRigaAperta(null)}
                              onToast={onToast}
                            />
                          </td>
                        </tr>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}

// ── Sezione 3: Rilancio routine pipeline ────────────────────────
function SezioneRilancioRoutine() {
  const ROUTINE_MATTINA     = "/pipeline/routine-mattina";
  const ROUTINE_CICLO       = "/pipeline/routine-ciclo";
  const ROUTINE_GIORNALIERA = "/pipeline/routine-giornaliera";

  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [aperta, setAperta] = useState(false);

  const esegui = async (endpoint, label) => {
    setLoading(true);
    setMsg(`${label} in corso...`);
    try {
      const r = await fetch(`${API}${endpoint}`, { method: "POST" });
      const d = await r.json();
      // v199: il segnale verde compariva anche quando la routine girava
      // ma segnalava errori. Tre stati distinti.
      if (d.esito === "errore") {
        const n = d.errori || 0;
        setMsg(`⚠️ ${label}: ${n} error${n === 1 ? "e" : "i"} rilevat${n === 1 ? "o" : "i"}`);
      } else {
        setMsg(`✅ ${label}: ${d.dettaglio || d.esito || "OK"}`);
      }
    } catch (e) {
      setMsg(`❌ ${label}: ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  const ROUTINE = [
    { label: "Rilancia Routine Mattina",     endpoint: ROUTINE_MATTINA,     tooltip: "Ripete la routine delle ore 6:00 IT: importa le quote 5mKO delle partite di ieri e i risultati HT/FT da SoccerSTAT, calcola i P/L e aggiorna i punti delle selezioni.\n\nUsa solo se la routine automatica è andata in errore." },
    { label: "Rilancia Routine Ciclo",       endpoint: ROUTINE_CICLO,       tooltip: "Ripete la routine del martedì/venerdì ore 9:15 IT: importa le quote ore 9 e crea le partite del nuovo ciclo, importa le quote ore 8, calcola i parametri statistici, ricalcola le selezioni e invia la mail Programma.\n\nUsa solo se la routine automatica è andata in errore." },
    { label: "Rilancia Routine Giornaliera", endpoint: ROUTINE_GIORNALIERA, tooltip: "Ripete la routine delle ore 8:15 IT: importa le quote ore 8 di oggi, ricalcola le selezioni (incluse condizioni in attesa) e invia la mail di aggiornamento.\n\nUsa solo se la routine automatica è andata in errore." },
  ];

  return (
    <div style={stili.card}>
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
        onClick={() => setAperta(a => !a)}
      >
        <div style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
          Rilancio routine pipeline
        </div>
        <span style={{ fontSize: 16, color: "#64748B", userSelect: "none" }}>
          {aperta ? "▲" : "▼"}
        </span>
      </div>

      {aperta && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 12, color: "#64748B", marginBottom: 14 }}>
            Usa solo se una routine automatica è andata in errore e vuoi rilanciarla manualmente.
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
            {ROUTINE.map(({ label, endpoint, tooltip }) => (
              <button
                key={endpoint}
                style={{ ...stili.btn, ...stili.btnSecondary, opacity: loading ? 0.6 : 1 }}
                onClick={e => { e.stopPropagation(); esegui(endpoint, label); }}
                disabled={loading}
                title={tooltip}
              >
                {label}
              </button>
            ))}
            {msg && (
              <span style={{
                fontSize: 12, color: msg.startsWith("✅") ? "#16A34A" : msg.startsWith("⚠️") ? "#D97706" : msg.startsWith("❌") ? "#DC2626" : "#64748B",
                padding: "4px 10px", background: "#F8FAFC",
                borderRadius: 6, border: "1px solid #E2E8F0",
              }}>
                {msg}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Sezione 4: Storico interventi ───────────────────────────────
// ═══════════════════════════════════════════════════════════════
// CORREZIONE NOME SQUADRA (Blocco 3, v194)
// ═══════════════════════════════════════════════════════════════
// Procedura a tre tappe. La tappa 1 (traduzione presente) si valuta solo
// dopo aver scelto i due nomi: prima non c'e' niente da controllare.
// Nessun passo e' affidato alla memoria dell'utente: ogni tappa dice da sola
// cosa manca. Il rifiuto (sovrapposizione, traduzione assente) vive anche nel
// backend: l'interfaccia non e' l'unica difesa.

function TappaTitolo({ n, stato, titolo }) {
  // stato: "ok" | "avviso" | "attiva" | "spenta"
  const col = {
    ok:      { bg: "#DCFCE7", fg: "#166534", ch: "✓" },
    avviso:  { bg: "#FEF3C7", fg: "#92400E", ch: "!" },
    attiva:  { bg: "#DBEAFE", fg: "#1E40AF", ch: String(n) },
    spenta:  { bg: "#F1F5F9", fg: "#94A3B8", ch: String(n) },
  }[stato];
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 8 }}>
      <span style={{
        width: 22, height: 22, borderRadius: "50%",
        background: col.bg, color: col.fg,
        fontSize: 11, fontWeight: 700,
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, fontFamily: FONT,
      }}>{col.ch}</span>
      <span style={{
        fontSize: 13, fontWeight: 600,
        color: stato === "spenta" ? "#94A3B8" : "#1E293B",
      }}>{n} · {titolo}</span>
    </div>
  );
}

function RiquadroEsito({ tono, children }) {
  const c = {
    ok:      { bg: "#F0FDF4", bd: "#639922", fg: "#27500A" },
    avviso:  { bg: "#FFFBEB", bd: "#EF9F27", fg: "#854F0B" },
    errore:  { bg: "#FEF2F2", bd: "#E24B4A", fg: "#791F1F" },
    info:    { bg: "#EFF6FF", bd: "#3B82F6", fg: "#0C447C" },
  }[tono];
  return (
    <div style={{
      background: c.bg, borderLeft: `3px solid ${c.bd}`,
      padding: "9px 12px", fontSize: 12, color: c.fg,
      lineHeight: 1.6, fontFamily: FONT,
    }}>{children}</div>
  );
}

function SezioneCorrezioneSquadra({ onToast, onIntervento }) {
  const [aperta, setAperta] = useState(false);
  const [legheLista, setLegheLista] = useState([]);
  const [stagioniLista, setStagioniLista] = useState([]);
  const [lega, setLega] = useState("");
  const [stagione, setStagione] = useState("");
  const [squadre, setSquadre] = useState([]);
  const [caricandoSquadre, setCaricandoSquadre] = useState(false);
  const [errato, setErrato] = useState("");
  const [corretto, setCorretto] = useState("");
  const [verifica, setVerifica] = useState(null);
  const [verificando, setVerificando] = useState(false);
  const [lavoro, setLavoro] = useState(null);   // riga di correzioni_squadre
  const [avviando, setAvviando] = useState(false);
  const [errore, setErrore] = useState("");

  useEffect(() => {
    fetch(`${API}/campionati`).then(r => r.json())
      .then(d => { if (Array.isArray(d)) setLegheLista(d.map(c => c.nome_bf || c.nome || String(c))); })
      .catch(() => {});
    fetch(`${API}/stagioni`).then(r => r.json())
      .then(d => { if (Array.isArray(d)) setStagioniLista([...d].sort().reverse()); })
      .catch(() => {});
  }, []);

  // Riprende un lavoro gia' in corso: la barra non riparte da zero se cambi pagina.
  useEffect(() => {
    fetch(`${API}/squadre/correzione-attiva`).then(r => r.json())
      .then(d => { if (d && d.id) { setLavoro(d); setAperta(true); } })
      .catch(() => {});
  }, []);

  // Polling finche' il lavoro e' in corso.
  useEffect(() => {
    if (!lavoro || !lavoro.id) return;
    if (lavoro.stato === "completata" || lavoro.stato === "errore") return;
    const t = setInterval(async () => {
      try {
        const r = await fetch(`${API}/squadre/correzione/${lavoro.id}`);
        const d = await r.json();
        if (d && d.id) setLavoro(d);
      } catch { /* riprova al giro dopo */ }
    }, 5000);
    return () => clearInterval(t);
  }, [lavoro]);

  // Carica l'elenco squadre. Rilanciabile: dopo una correzione i nomi cambiano
  // e l'elenco vecchio conterrebbe una squadra che non esiste piu'.
  const ricaricaSquadre = () => {
    setErrato(""); setCorretto(""); setVerifica(null); setSquadre([]);
    if (!lega || !stagione) return;
    setCaricandoSquadre(true);
    fetch(`${API}/squadre/elenco?lega=${encodeURIComponent(lega)}&stagione=${encodeURIComponent(stagione)}`)
      .then(r => r.json())
      .then(d => setSquadre(Array.isArray(d.squadre) ? d.squadre : []))
      .catch(() => setSquadre([]))
      .finally(() => setCaricandoSquadre(false));
  };

  useEffect(() => {
    ricaricaSquadre();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lega, stagione]);

  // Verifica automatica appena entrambi i nomi sono scelti.
  useEffect(() => {
    setVerifica(null);
    setErrore("");
    if (!lega || !stagione || !errato || !corretto || errato === corretto) return;
    setVerificando(true);
    const q = `lega=${encodeURIComponent(lega)}&stagione=${encodeURIComponent(stagione)}`
            + `&errato=${encodeURIComponent(errato)}&corretto=${encodeURIComponent(corretto)}`;
    fetch(`${API}/squadre/verifica-correzione?${q}`)
      .then(r => r.json())
      .then(d => setVerifica(d && d.lega ? d : null))
      .catch(() => setVerifica(null))
      .finally(() => setVerificando(false));
  }, [lega, stagione, errato, corretto]);

  // v194: il rifiuto del backend arriva come elenco di codici. Tradotti, perche'
  // "Correzione non consentita" da solo non dice all'utente cosa è successo.
  const MOTIVI_RIFIUTO = {
    nome_assente: "il nome da correggere non compare più in nessuna partita: la correzione è già stata fatta",
    sovrapposizione: "i due nomi giocano nelle stesse giornate: sono squadre diverse",
    mapping_mancante: "la traduzione del nome nuovo non è presente in Impostazioni",
  };

  const avvia = async () => {
    if (!verifica || !verifica.eseguibile) return;
    setAvviando(true);
    setErrore("");
    try {
      const r = await fetch(`${API}/squadre/correggi`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lega, stagione, errato, corretto }),
      });
      const d = await r.json();
      if (!r.ok || !d.id) {
        const codici = Array.isArray(d.blocchi) ? d.blocchi : [];
        const spieg = codici.map(c => MOTIVI_RIFIUTO[c] || c).join("; ");
        throw new Error(spieg
          ? `Correzione non consentita: ${spieg}.`
          : (d.detail || `Errore ${r.status}`));
      }
      const s = await fetch(`${API}/squadre/correzione/${d.id}`).then(x => x.json());
      setLavoro(s && s.id ? s : { id: d.id, stato: "in_corso" });
    } catch (e) {
      setErrore(e.message);
      ricaricaSquadre();
    } finally {
      setAvviando(false);
    }
  };

  const chiudiLavoro = () => {
    setLavoro(null);
    ricaricaSquadre();
  };

  // Quando il lavoro si conclude, i nomi in elenco non sono piu' quelli:
  // ricaricarli evita di lasciare in pagina una squadra che non esiste piu'.
  useEffect(() => {
    if (!lavoro) return;
    if (lavoro.stato === "completata" || lavoro.stato === "errore") {
      ricaricaSquadre();
      if (onIntervento) onIntervento();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lavoro && lavoro.stato]);

  const inCorso = !!(lavoro && lavoro.stato !== "completata" && lavoro.stato !== "errore");
  const bloccato = (k) => !!(verifica && (verifica.blocchi || []).includes(k));

  // ── Stato della tappa 1 ──
  // Se la coppia e' gia' impossibile (sovrapposizione, nome assente), la
  // traduzione non c'entra: dare un consiglio su di essa sposterebbe
  // l'attenzione sul problema sbagliato. La tappa resta in attesa.
  const coppiaImpossibile = bloccato("sovrapposizione") || bloccato("nome_assente");
  let statoTappa1 = "spenta";
  let testoTappa1 = "Si valuta quando hai scelto i due nomi.";
  if (verifica && coppiaImpossibile) {
    statoTappa1 = "spenta";
    testoTappa1 = "In attesa di una coppia di nomi valida.";
  } else if (verifica) {
    if (verifica.mapping_presente) {
      statoTappa1 = "ok";
      testoTappa1 = `${errato} è già tradotto in ${corretto}. Puoi proseguire.`;
    } else {
      statoTappa1 = "avviso";
      testoTappa1 = verifica.mapping_altro
        ? `${errato} è tradotto in ${verifica.mapping_altro}, non in ${corretto}. Correggi la traduzione prima di procedere.`
        : `${errato} non è ancora tradotto. Senza la traduzione il prossimo scarico ricrea la squadra sbagliata e questo lavoro andrebbe perso.`;
    }
  }

  const perc = lavoro && lavoro.partite_da_ricalcolare
    ? Math.round(100 * (lavoro.partite_ricalcolate || 0) / lavoro.partite_da_ricalcolare)
    : 0;

  return (
    <div style={stili.card}>
      <div
        onClick={() => setAperta(a => !a)}
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
      >
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
            🔤 Correggi il nome di una squadra
          </div>
          <div style={{ fontSize: 12, color: "#64748B", marginTop: 3, lineHeight: 1.5, maxWidth: 720 }}>
            Da usare quando l'import del file di Investisport Quote porta nel database una squadra
            con un nome non ancora mappato, e il sistema la crea come squadra nuova invece di riconoscerla.
          </div>
        </div>
        <span style={{ fontSize: 13, color: "#64748B", marginLeft: 12 }}>{aperta ? "▲" : "▼"}</span>
      </div>

      {aperta && (
        <div style={{ marginTop: 16 }}>

          {/* ── Lavoro in corso o appena concluso ── */}
          {lavoro && (
            <div style={{
              border: "1px solid #E2E8F0", borderRadius: 8,
              padding: "14px 16px", marginBottom: 16, background: "#F8FAFC",
            }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1E293B", marginBottom: 8 }}>
                {lavoro.nome_errato} → {lavoro.nome_corretto} · {lavoro.lega} {lavoro.stagione}
              </div>

              {lavoro.stato === "errore" ? (
                <RiquadroEsito tono="errore">
                  La correzione si è fermata: {lavoro.errore || "motivo non registrato"}.
                  Le partite già rinominate sono {lavoro.partite_rinominate || 0}.
                </RiquadroEsito>
              ) : lavoro.stato === "completata" ? (
                <RiquadroEsito tono="ok">
                  Fatto. {lavoro.partite_rinominate} partite hanno cambiato nome,
                  {" "}{lavoro.partite_ricalcolate} sono state ricalcolate.
                </RiquadroEsito>
              ) : (
                <>
                  <div style={{
                    height: 8, borderRadius: 4, background: "#E2E8F0",
                    overflow: "hidden", marginBottom: 7,
                  }}>
                    <div style={{
                      height: "100%", width: `${perc}%`,
                      background: "#2563EB", transition: "width 0.4s",
                    }} />
                  </div>
                  <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
                    {lavoro.partite_rinominate > 0 && (
                      <>
                        <span style={{ color: "#166534" }}>
                          ✓ {lavoro.partite_rinominate} partite hanno già cambiato nome.
                        </span><br />
                      </>
                    )}
                    {lavoro.stato === "in_corso"
                      ? "Cambio nome in corso…"
                      : `Ricalcolo: ${lavoro.partite_ricalcolate || 0} di ${lavoro.partite_da_ricalcolare} partite.`}
                    <br />
                    <span style={{ color: "#94A3B8" }}>
                      Il ricalcolo procede a blocchi da 50 partite e ogni blocco richiede qualche minuto:
                      la barra resta ferma finché un blocco non è concluso.
                      Puoi cambiare pagina: tornando qui ritrovi l'avanzamento.
                    </span>
                  </div>
                </>
              )}

              {!inCorso && (
                <button
                  onClick={chiudiLavoro}
                  style={{ ...stili.btn, ...stili.btnSecondary, marginTop: 10, fontSize: 12 }}
                >Chiudi</button>
              )}
            </div>
          )}

          {!inCorso && (
            <>
              {/* ── Tappa 1 ── */}
              <div style={{ borderTop: "1px solid #E2E8F0", paddingTop: 14, marginBottom: 4 }}>
                <TappaTitolo n={1} stato={statoTappa1} titolo="La traduzione del nome nuovo" />
                <div style={{ paddingLeft: 32 }}>
                  <div style={{ fontSize: 12, color: "#64748B", lineHeight: 1.6, marginBottom: statoTappa1 === "avviso" ? 9 : 0 }}>
                    {testoTappa1}
                  </div>
                  {statoTappa1 === "avviso" && (
                    <span style={{ fontSize: 12, color: "#2563EB" }}>
                      Vai in Impostazioni → Mapping Betfair → DB e aggiungi la traduzione,
                      poi torna qui: il controllo si aggiorna da solo.
                    </span>
                  )}
                </div>
              </div>

              {/* ── Tappa 2 ── */}
              <div style={{ borderTop: "1px solid #E2E8F0", paddingTop: 14, marginTop: 14 }}>
                <TappaTitolo n={2} stato="attiva" titolo="Scegli i due nomi" />
                <div style={{ paddingLeft: 32 }}>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
                    <div>
                      <label style={stili.label}>Campionato</label>
                      <select style={{ ...stili.select, minWidth: 220 }} value={lega} onChange={e => setLega(e.target.value)}>
                        <option value="">— scegli —</option>
                        {legheLista.map(l => <option key={l} value={l}>{l}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={stili.label}>Stagione</label>
                      <select style={stili.select} value={stagione} onChange={e => setStagione(e.target.value)}>
                        <option value="">— scegli —</option>
                        {stagioniLista.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>

                  {caricandoSquadre && (
                    <div style={{ fontSize: 12, color: "#64748B" }}>Carico le squadre…</div>
                  )}

                  {squadre.length > 0 && (
                    <>
                      <div style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 10 }}>
                        <div>
                          <label style={stili.label}>Nome da correggere</label>
                          <select style={{ ...stili.select, minWidth: 220 }} value={errato} onChange={e => setErrato(e.target.value)}>
                            <option value="">— scegli —</option>
                            {squadre.map(s => (
                              <option key={s.nome} value={s.nome}>{s.nome} ({s.partite})</option>
                            ))}
                          </select>
                        </div>
                        <span style={{ fontSize: 15, color: "#94A3B8", paddingBottom: 7 }}>→</span>
                        <div>
                          <label style={stili.label}>Nome corretto</label>
                          <select style={{ ...stili.select, minWidth: 220 }} value={corretto} onChange={e => setCorretto(e.target.value)}>
                            <option value="">— scegli —</option>
                            {squadre.filter(s => s.nome !== errato).map(s => (
                              <option key={s.nome} value={s.nome}>{s.nome} ({s.partite})</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      </>
                  )}

                  {verificando && (
                    <div style={{ fontSize: 12, color: "#64748B" }}>Controllo in corso…</div>
                  )}

                  {verifica && !verificando && (() => {
                    const a = squadre.find(s => s.nome === errato);
                    const b = squadre.find(s => s.nome === corretto);
                    return (
                      <>
                        {a && b && (
                          <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                            {[b, a].map(x => (
                              <div key={x.nome} style={{
                                background: "#F8FAFC", borderRadius: 8, padding: "10px 13px", minWidth: 200,
                              }}>
                                <div style={{ fontSize: 12, fontWeight: 600, color: "#1E293B", marginBottom: 4 }}>{x.nome}</div>
                                <div style={{ fontSize: 11, color: "#64748B", lineHeight: 1.6 }}>
                                  {x.partite} partite<br />
                                  dal {fmtDataIT(x.prima)} al {fmtDataIT(x.ultima)}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {bloccato("nome_assente") ? (
                          <RiquadroEsito tono="errore">
                            {errato} non compare in nessuna partita di questo campionato e stagione.
                          </RiquadroEsito>
                        ) : bloccato("sovrapposizione") ? (
                          <RiquadroEsito tono="errore">
                            I due nomi compaiono nella stessa giornata {verifica.sovrapposizioni} volte
                            {verifica.sovrapposizioni_date && verifica.sovrapposizioni_date.length > 0
                              ? ` (per esempio il ${fmtDataIT(verifica.sovrapposizioni_date[0])})` : ""}.
                            Sono due squadre diverse, non lo stesso club scritto in due modi: unirle rovinerebbe i dati.
                            Correzione non consentita.
                          </RiquadroEsito>
                        ) : (
                          <RiquadroEsito tono="ok">
                            {corretto} gioca fino al {fmtDataIT(b ? b.ultima : null)},
                            {" "}{errato} dal {fmtDataIT(a ? a.prima : null)}.
                            Mai nella stessa giornata: compatibile con lo stesso club scritto in due modi.
                          </RiquadroEsito>
                        )}
                      </>
                    );
                  })()}
                </div>
              </div>

              {/* ── Tappa 3 ── */}
              <div style={{ borderTop: "1px solid #E2E8F0", paddingTop: 14, marginTop: 14 }}>
                <TappaTitolo
                  n={3}
                  stato={verifica && verifica.eseguibile ? "attiva" : "spenta"}
                  titolo="Controlla e conferma"
                />
                <div style={{ paddingLeft: 32 }}>
                  {!verifica || !verifica.eseguibile ? (
                    <div style={{ fontSize: 12, color: "#94A3B8" }}>
                      Si apre quando le prime due tappe sono a posto.
                    </div>
                  ) : (
                    <>
                      <div style={{ marginBottom: 12 }}>
                        {[
                          ["Partite che cambiano nome", verifica.partite_da_rinominare],
                          ["Prima partita interessata", fmtDataIT(verifica.prima_data)],
                          ["Partite del campionato da ricalcolare", verifica.partite_da_ricalcolare],
                          ["Squadre nel campionato, dopo", `${verifica.squadre_dopo} (ora ${verifica.squadre_ora})`],
                        ].map(([k, v]) => (
                          <div key={k} style={{
                            display: "flex", justifyContent: "space-between",
                            padding: "7px 0", borderTop: "1px solid #F1F5F9", fontSize: 12,
                          }}>
                            <span style={{ color: "#64748B" }}>{k}</span>
                            <span style={{ color: "#1E293B", fontWeight: 600 }}>{v}</span>
                          </div>
                        ))}
                      </div>

                      <div style={{ marginBottom: 12 }}>
                        <RiquadroEsito tono="avviso">
                          Il ricalcolo tocca tutte le partite del campionato dal {fmtDataIT(verifica.prima_data)} in poi,
                          non solo quelle di {corretto}: finché le squadre risultavano {verifica.squadre_ora},
                          le fasce di classifica erano sbagliate per tutti.
                        </RiquadroEsito>
                      </div>

                      {errore && (
                        <div style={{ marginBottom: 10 }}>
                          <RiquadroEsito tono="errore">{errore}</RiquadroEsito>
                        </div>
                      )}

                      <button
                        onClick={avvia}
                        disabled={avviando}
                        style={{ ...stili.btn, ...stili.btnPrimary, opacity: avviando ? 0.6 : 1 }}
                      >{avviando ? "Avvio…" : "Correggi e ricalcola"}</button>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

function SezioneStoricoInterventi({ refresh }) {
  const [interventi, setInterventi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [aperto, setAperto] = useState(false);
  const PAGE = 50;

  const carica = async (append = false) => {
    setLoading(true);
    setErrore("");
    try {
      const offset = append ? interventi.length : 0;
      const r = await fetch(`${API}/interventi?limit=${PAGE + 1}&offset=${offset}`);
      if (!r.ok) throw new Error(`Errore ${r.status}`);
      const d = await r.json();
      const lista = Array.isArray(d) ? d : [];
      const more = lista.length > PAGE;
      const page = more ? lista.slice(0, PAGE) : lista;
      setHasMore(more);
      if (append) setInterventi(prev => [...prev, ...page]);
      else setInterventi(page);
    } catch (e) {
      setErrore(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { carica(); }, [refresh]);

  const TIPO_BADGE = {
    "Modifica quota":       { bg: "#DBEAFE", color: "#1D4ED8" },
    "Inserimento risultato":{ bg: "#D1FAE5", color: "#065F46" },
    "Eliminazione partita": { bg: "#FFEBEE", color: "#C62828" },
  };

  return (
    <div style={stili.card}>
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
        onClick={() => setAperto(a => !a)}
      >
        <div style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
          Storico interventi
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 11, color: "#94A3B8" }}>Ultimi 30 giorni</span>
          <span style={{ fontSize: 16, color: "#64748B", userSelect: "none" }}>{aperto ? "▲" : "▼"}</span>
        </div>
      </div>

      {aperto && (
        <div style={{ marginTop: 14 }}>
          {loading && interventi.length === 0 && (
            <div style={{ fontSize: 13, color: "#64748B" }}>Caricamento...</div>
          )}
          {errore && (
            <div style={{ fontSize: 13, color: "#EF4444" }}>⚠️ {errore}</div>
          )}

          {!errore && interventi.length === 0 && !loading && (
            <div style={{ fontSize: 13, color: "#94A3B8", padding: "8px 0" }}>
              Nessun intervento registrato.
            </div>
          )}

          {interventi.length > 0 && (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {["Data partita", "Ora", "Lega", "Casa", "Trasferta", "Tipo", "Campo", "Prima", "Dopo", "Eseguito"].map(h => (
                      <th key={h} style={stili.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {interventi.map((iv, i) => {
                    const badge = TIPO_BADGE[iv.tipo] || { bg: "#F1F5F9", color: "#475569" };
                    return (
                      <tr key={iv.id || i} style={{ background: i % 2 === 0 ? "#fff" : "#FAFBFC" }}>
                        <td style={stili.td}>{iv.p_data ? fmtData(iv.p_data) : "—"}</td>
                        <td style={{ ...stili.td, fontFamily: MONO, fontSize: 11 }}>{iv.p_time_it ? String(iv.p_time_it).substring(0,5) : "—"}</td>
                        <td style={stili.td}>{iv.p_lega || "—"}</td>
                        <td style={stili.td}>{iv.p_casa || "—"}</td>
                        <td style={stili.td}>{iv.p_trasferta || "—"}</td>
                        <td style={stili.td}>
                          <span style={{
                            display: "inline-block", padding: "2px 8px", borderRadius: 4,
                            fontSize: 11, fontWeight: 600,
                            background: badge.bg, color: badge.color,
                          }}>
                            {iv.tipo || "—"}
                          </span>
                        </td>
                        <td style={{ ...stili.td, fontFamily: MONO, fontSize: 11 }}>
                          {iv.campo || "—"}
                        </td>
                        <td style={{ ...stili.td, fontFamily: MONO, fontSize: 11, color: "#94A3B8" }}>
                          {iv.valore_prima ?? "—"}
                        </td>
                        <td style={{ ...stili.td, fontFamily: MONO, fontSize: 11, fontWeight: 600 }}>
                          {iv.valore_dopo ?? "—"}
                        </td>
                        {/* v194: quando l'intervento e' stato fatto. Le colonne Data e Ora
                            sono della partita, non dell'intervento: senza questa mancava
                            del tutto la data dell'azione. */}
                        <td style={{ ...stili.td, fontFamily: MONO, fontSize: 11, color: "#94A3B8" }}>
                          {fmtTimestamp(iv.eseguito_at)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {hasMore && (
            <div style={{ textAlign: "center", marginTop: 12 }}>
              <button
                style={{ ...stili.btn, ...stili.btnSecondary, fontSize: 12 }}
                onClick={() => carica(true)}
                disabled={loading}
              >
                {loading ? "Caricamento..." : "Mostra altri"}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── Componente principale ────────────────────────────────────────
function Toast({ msg, onClose }) {
  useEffect(() => {
    if (!msg) return;
    const t = setTimeout(onClose, 6000);
    return () => clearTimeout(t);
  }, [msg, onClose]);

  if (!msg) return null;
  return (
    <div style={{
      position: "fixed", top: 24, right: 24, zIndex: 9999,
      background: "#F0FDF4", border: "1px solid #86EFAC",
      borderRadius: 10, padding: "14px 20px", maxWidth: 420,
      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
      fontFamily: FONT, fontSize: 13, color: "#15803D",
      whiteSpace: "pre-line", lineHeight: 1.6,
    }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
        <span style={{ flex: 1 }}>{msg}</span>
        <span
          onClick={onClose}
          style={{ cursor: "pointer", color: "#86EFAC", fontSize: 16, lineHeight: 1, marginTop: 1 }}
        >✕</span>
      </div>
    </div>
  );
}

export default function InterventiDB() {
  const [refreshStorico, setRefreshStorico] = useState(0);
  const [toastMsg, setToastMsg] = useState("");

  const onIntervento = () => setRefreshStorico(r => r + 1);
  const onToast = (msg) => setToastMsg(msg);

  return (
    <div style={stili.pagina}>
      <Toast msg={toastMsg} onClose={() => setToastMsg("")} />
      <h1 style={stili.titolo}>🏥 Interventi su DB</h1>
      <p style={{ fontSize: 13, color: "#64748B", marginBottom: 24 }}>
        Risolvi anomalie su quote e risultati e gestisci interventi manuali sui dati.
      </p>
      <SezioneAnomalie onIntervento={onIntervento} onToast={onToast} />
      <SezioneRicercaLibera onIntervento={onIntervento} onToast={onToast} />
      <SezioneCorrezioneSquadra onToast={onToast} onIntervento={onIntervento} />
      <SezioneStoricoInterventi refresh={refreshStorico} />
      <SezioneRilancioRoutine />
    </div>
  );
}
